var path = 'public/app/features/plugins/partials/plugin_page.html';
var html = "<div ng-if=ctrl.navModel>\n  <page-header model=ctrl.navModel></page-header>\n\n  <div class=page-container>\n    <div ng-if=ctrl.page>\n      <plugin-component type=app-page>\n      </plugin-component>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/plugins/partials/plugin_page.html
// module id = 1093
// module chunks = 3